(function () {
  var TITLE_FALLBACK = {
    'box-gatto': 'BOX PER GATTI',
    'box-cane': 'BOX PER CANI',
    'box-degustazione': 'BOX DEGUSTAZIONE'
  };

  var animating = false;
  var animFrame = 0;

  function headerOffset() {
    var header = document.querySelector('#shopify-section-header') || document.querySelector('sticky-header');
    return header ? Math.round(header.getBoundingClientRect().height) + 16 : 140;
  }

  function currentY() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  function findTarget(id) {
    if (!id) return null;
    return (
      document.querySelector('[data-life-anchor="' + id + '"]') ||
      document.getElementById(id) ||
      document.getElementById('shopify-section-' + id) ||
      document.getElementById('shopify-section-' + id.replace(/-/g, '_')) ||
      findByHeadingText(TITLE_FALLBACK[id])
    );
  }

  function findByHeadingText(text) {
    if (!text) return null;
    var headings = document.querySelectorAll('h2, h1');
    for (var i = 0; i < headings.length; i++) {
      var label = (headings[i].textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (label === text) {
        return headings[i].closest('.shopify-section') || headings[i];
      }
    }
    return null;
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function durationForDistance(distance) {
    var px = Math.abs(distance);
    return Math.round(Math.min(1600, Math.max(900, 700 + px * 0.45)));
  }

  function animateScrollTo(top) {
    var start = currentY();
    var change = top - start;
    if (Math.abs(change) < 2) return;

    if (animFrame) window.cancelAnimationFrame(animFrame);
    animating = true;

    var duration = durationForDistance(change);
    var startTime = null;

    function step(now) {
      if (!startTime) startTime = now;
      var progress = Math.min(1, (now - startTime) / duration);
      var y = start + change * easeInOutCubic(progress);
      window.scrollTo(0, y);
      if (progress < 1) {
        animFrame = window.requestAnimationFrame(step);
      } else {
        animating = false;
        animFrame = 0;
      }
    }

    animFrame = window.requestAnimationFrame(step);
  }

  function scrollToTarget(target) {
    if (!target) return false;
    var top = target.getBoundingClientRect().top + currentY() - headerOffset();
    animateScrollTo(Math.max(0, top));
    return true;
  }

  function go(id) {
    return scrollToTarget(findTarget(id));
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-life-acq-scroll]');
      if (!trigger) return;
      var id = trigger.getAttribute('data-life-acq-scroll');
      if (!id) return;
      event.preventDefault();
      event.stopPropagation();
      go(id);
    },
    true
  );

  function fromHash() {
    var hash = window.location.hash.replace('#', '');
    if (hash) go(hash);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fromHash);
  } else {
    fromHash();
  }
})();
